import user from "@/services/user.service"
import { debounce } from "lodash"
import store from "@/store"
interface UserPatcher {
    uids: Array<keyof any> //待查询的uid
    patchUser: any
}
export interface UserDomain {
    uid: number
    thumb_avatar: string
    name: string
    email: string
    department_name: string
    department_id: string
}
export interface UserMapper {
    [uid: number]: UserDomain
}
const buildUserPatcher = (mutation = "user/patchUser"): UserPatcher => {
    return new Proxy(
        {
            uids: [],
            patchUser: debounce(function(this: UserPatcher, uids) {
                if (uids && uids.length) {
                    user.getUserListByUids({
                        uids
                    }).then(res => {
                        store.commit(mutation, res)
                    })
                    this.uids = [] //请求一旦发出就清空id,避免不必要的重复查询
                }
            }, 1000)
        },
        {
            set(target, property, value) {
                if (property === "uids" && Array.isArray(value)) {
                    const legalValue = value.filter(Boolean)
                    target.patchUser(legalValue)
                    return Reflect.set(target, property, legalValue)
                }
                return Reflect.set(target, property, value)
            }
        }
    )
}
//vue-devtool会将代理对象解释为Store,需要补充state和getters,避免开发者理解歧义
const buildUserProxy = (userMap: UserMapper, patcher: UserPatcher): UserMapper => {
    return new Proxy(
        {
            ...userMap,
            state: userMap,
            getters: userMap
        },
        {
            get(target, prop, receiver): UserDomain {
                if (store.getters.allOrgs[prop]) {
                    return undefined
                }
                if (Reflect.has(target, prop)) {
                    return Reflect.get(target, prop, receiver)
                } else {
                    const uids = Reflect.get(patcher, "uids", receiver)
                    const uid = Number(prop.toString().replace(/^Symbol\((.*)\)$/, "$1"))
                    const uniqueUid = Array.from(new Set([...uids, uid]))
                    const legalUids = uniqueUid.filter(Boolean)
                    Reflect.set(patcher, "uids", legalUids)
                    return {
                        uid: uid,
                        thumb_avatar: "",
                        name: "未知",
                        email: "",
                        department_name: "",
                        department_id: ""
                    }
                }
            }
        }
    )
}
export { buildUserPatcher, buildUserProxy }
